import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { ctaClasses } from "../utils/cta";
type OfferLinkProps = {
  label: string;
  className?: string;
};

// Top and mid-page buttons: scroll to the main offer section.
export function OfferLink({
  label,
  className = ""
}: OfferLinkProps) {
  return <a href="#offer" className={`${ctaClasses} ${className}`} data-id="element-163" data-mp="3jukeosrzznk5">
      <span data-id="element-164" data-mp="3jx6mmtisw52w">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" strokeWidth={2.75} aria-hidden="true" data-id="element-165" data-mp="2w4q28cblc10f" />
    </a>;
}